import {
  getContactsToNotifyAsync,
  updateContactsToNotifyAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useGetContactsToNotify = () =>
  useMutation(getContactsToNotifyAsync);

export const useUpdateContactsToNotify = () =>
  useMutation(updateContactsToNotifyAsync);
